import * as React from 'react'

const SQL = () => {
  return (
    <div>
      SQL
    </div>
  )
}

export default SQL
